import React from "react";
import { useNavigate } from "react-router-dom";
import BrandHeader from "./BrandHeader";
import { useLang } from "../LangContext";
import "./LegalShell.css";

interface Props {
  children: React.ReactNode;
}

export default function LegalShell({ children }: Props) {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <main className="legal-page">
      <div className="legal-container">
        <BrandHeader />
        <div className="legal-card">
          <button
            type="button"
            className="legal-back-link"
            onClick={() => { navigate(-1); window.scrollTo(0, 0); }}
          >
            &larr; {t.back}
          </button>
          {children}
        </div>
      </div>
    </main>
  );
}
